import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chime-users',
  templateUrl: './chime-users.component.html',
  styleUrls: ['./chime-users.component.scss']
})
export class ChimeUsersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
